import React from 'react';

export default function Nav() {
    return (
        <nav>
            <ul>
                <li>
                    <a href="#welcome">Home</a>
                </li>
                <li>
                    <a href="#stories">Stories</a>
                </li>
                <li>
                    <a href="#goals">Word Count</a>
                </li>
                <li>
                    <a href="#faq">FAQ</a>
                </li>
            </ul>
        </nav>
    )
}